import moment from 'moment';

export const formatSecondsToMinutes = seconds => {
  const duration = moment.duration(seconds, 'seconds');
  if (!duration.isValid()) return '-';
  return `${Math.round(duration.asMinutes())} min`;
};

export const formatSecondsToEstLabel = seconds => {
  const totalMinutes = Math.round(moment.duration(seconds, 'seconds').asMinutes());
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};
